import React from 'react'

import {QuestionContainer} from './BookingQuestion.styled'

import {Typography} from '~/components/general/typography/Typography'

type Props = {
  title: React.ReactNode
  subtitle?: React.ReactNode
  children: React.ReactNode
}

export const BookingQuestion: React.FC<Props> = ({
  title,
  subtitle,
  children,
}) => (
  <QuestionContainer direction="column" spacing={1}>
    <Typography weight="medium">{title}</Typography>
    {subtitle ? <Typography size="sm">{subtitle}</Typography> : null}
    {children}
  </QuestionContainer>
)
